/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";
import { Row, Col, Modal, Button, FormControl, Form, Pagination } from "react-bootstrap";
import { Backr, Table } from "./styles";
import api from "../../../../services/api";

interface ContratoEmpresa {
  codigo: number;
  emailresponsavel: string;
  empresa_codigo: number;
  empresa_nome: string;
  empresa_fantasia: string;
  planocontratado: string;
  qtdepacientes: number;
  representante_com_id?: number;
  representante_cs1_id?: number;
  responsavel: string;
  empresa_cgc: string;
}

interface AdminUser {
  id: string;
  name: string;
}

interface Props {
  role: string;
}

const BaseCreationToken: React.FC<Props> = ({ role }) => {
  const [listCS, setCS] = useState<ContratoEmpresa[]>([]);
  const [csUsers, setCsUsers] = useState<AdminUser[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [selectedToken, setSelectedToken] = useState<any | null>(null);
  const [selectedAdminId, setSelectedAdminId] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);

  useEffect(() => {
    async function loadTokens() {
      try {
        const response = await api.get(`/accounts_without_cs?page=${page}`);
        setCS(response.data.contracts);
        setTotalPages(response.data.total_pages);
      } catch (error) {
        toast.error("Erro ao carregar bases sem CS");
      }
    }
    loadTokens();
  }, [page]);

  useEffect(() => {
    async function loadAdminUsers() {
      const response = await api.get("/users/cs");
      setCsUsers(response.data);
    }
    loadAdminUsers();
  }, []);

  const handleClose = () => {
    setShow(false);
    setSelectedToken(null);
    setSelectedAdminId("");
  };

  const handleShow = (tokenData: any) => {
    setSelectedToken(tokenData);
    setShow(true);
  };

  async function acceptDataBaseCreation() {
    if (!selectedToken || !selectedAdminId) {
      toast.error("Por favor, selecione um responsável pelo CS");
      return;
    }

    try {
      const response = await api.post("/accounts_without_cs", {
        contract_id: selectedToken.contrato_codigo,
        cs_id: selectedAdminId,
      });

      toast.success(response.data.message);

      const updatedOpenedCS = await api.get(`/accounts_without_cs?page=${page}`);
      setCS(updatedOpenedCS.data.contracts);
      setTotalPages(updatedOpenedCS.data.total_pages);

      handleClose();
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Erro ao ativar base.");
    }
  }

  if (role !== "MASTER") {
    return null;
  }

  return (
    <div>
      <Backr>
        <h1>Bases sem CS</h1>
        {listCS.length > 0 ? (
          <>
            <Table>
              <thead>
                <tr>
                  <th>Clinica</th>
                  <th>Responsável</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {listCS.map((contratoEmpresa: ContratoEmpresa) => (
                  <tr key={contratoEmpresa.codigo}>
                    <td>
                      <div>
                        <span>{contratoEmpresa.empresa_nome} </span>
                        <span>{contratoEmpresa.empresa_fantasia}</span>
                        <br />
                        <span>{contratoEmpresa.empresa_cgc}</span>
                      </div>
                    </td>
                    <td>
                      <span>{contratoEmpresa.responsavel}</span>
                      <br />
                      <span>{contratoEmpresa.emailresponsavel}</span>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <Button
                        style={{ float: "right" }}
                        onClick={() => handleShow(contratoEmpresa)}
                      >
                        Definir CS
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Pagination className="justify-content-center mt-4" size="sm">
              <Pagination.Prev
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              />

              {[...Array(Math.min(5, totalPages))].map((_, idx) => {
                const startPage = Math.max(1, page - ((page - 1) % 5));
                const pageNumber = startPage + idx;

                if (pageNumber > totalPages) return null;

                return (
                  <Pagination.Item
                    key={pageNumber}
                    active={pageNumber === page}
                    onClick={() => setPage(pageNumber)}
                    aria-label={`${pageNumber}`}
                  >
                    {pageNumber}
                  </Pagination.Item>
                );
              })}

              <Pagination.Next
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              />
            </Pagination>

            <Modal show={show} onHide={handleClose}>
              <Modal.Header>
                <Modal.Title>Selecionar CS</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Row>
                    <Col xs={12}>
                      <FormControl
                        as="select"
                        value={selectedAdminId}
                        onChange={(e) => setSelectedAdminId(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          Selecione um responsável pelo CS
                        </option>
                        {csUsers.map((cs) => (
                          <option key={cs.id} value={cs.id}>
                            {cs.name}
                          </option>
                        ))}
                      </FormControl>
                    </Col>
                  </Row>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Col className="d-flex justify-content-end">
                  <Button variant="success" onClick={acceptDataBaseCreation}>
                    <FaCheck /> Confirmar
                  </Button>
                </Col>
              </Modal.Footer>
            </Modal>
          </>
        ) : (
          <p>Todas as bases ativas tem CS Responsavel</p>
        )}
      </Backr>
    </div>
  );
};

export default BaseCreationToken;
